// PWA update handler. VitePWA runs with clientsClaim+skipWaiting, which means
// the FIRST-EVER service worker activation on a brand new visit also fires
// `controllerchange` (clientsClaim immediately takes control of the page that
// just registered it) — not just later updates. Reloading on that first event
// wiped whatever the visitor had just typed (signup form, "find your
// business" input, mid-playback /story). Only a controllerchange that happens
// AFTER a controller already existed is a real update worth reloading for.
export function setupServiceWorkerReload(
  nav: Pick<ServiceWorkerContainer, 'ready' | 'controller' | 'addEventListener'>,
  win: Pick<Window, 'location'>,
  storage: Pick<Storage, 'getItem' | 'setItem'>,
) {
  let hadController = !!nav.controller

  nav.ready
    .then((registration) => registration.update())
    .catch(() => undefined)

  nav.addEventListener('controllerchange', () => {
    const isFirstActivation = !hadController
    hadController = true
    if (isFirstActivation) return

    if (storage.getItem('qordo_sw_reloaded')) return
    storage.setItem('qordo_sw_reloaded', '1')
    win.location.reload()
  })
}
